
import Vue from "vue";

import { Component, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ActionMethod } from "vuex";
import { tagNamePlan } from "@/helpers/TagNamePlanHelper";

import Dialog from "@/components/common/Dialog/index.vue";
import { homeTagEvents } from "@/modules/Gtm/gaExecuteEvents";
import { CouponType } from "@/types/CouponTypes";
import { CustomerType } from "@/types/CustomerTypes";

@Component({
  name: "Cupom",
  components: {
    Dialog,
  },
})
export default class Cupom extends Vue {
  @Prop({ default: "" }) readonly bonus!: string;
  @Prop({ default: "" }) readonly franchise!: string;
  @Prop({ default: "" }) readonly catalogId!: string;
  @Prop({ default: "" }) readonly tag!: string;
  @Prop({ default: "" }) readonly planId!: string;
  @Prop({ default: "" }) readonly couponCode!: string;
  @Prop({ default: false }) readonly lock!: boolean;
  @Prop({ default: false }) readonly isCarousel!: boolean;
  @Getter coupon!: CouponType;
  @Getter lockCoupons!: string[];
  @Getter customer!: CustomerType;
  @Getter isMeli!: boolean;
  @Action checkCupom!: ActionMethod;
  @Action setCoupon!: ActionMethod;
  @Action setCoupons!: ActionMethod;
  @Action updateCoupons!: ActionMethod;
  @Action validateCoupon!: ActionMethod;
  cupom = false;
  ticket = "";
  showModalAlert = false;
  alertMessage = "";
  alertError = "";
  ticketGood = "";
  ticketDesc = "";

  closeModalAlert() {
    this.showModalAlert = false;
  }

  isShow() {
    if (this.lock) return;

    this.cupom = true;

    homeTagEvents({
      custom_title: `clique-${tagNamePlan({
        bonus: this.bonus,
        franchise: this.franchise,
      })}:trocar`,
    });

    setTimeout(() => {
      if (this.$refs.cupom) {
        const cupomInput = this.$refs.cupom as HTMLInputElement;
        cupomInput.focus();
      }
    }, 100);
  }

  submit(ev = null, param = false) {
    if (this.lock) return;

    if (ev) {
      homeTagEvents({
        custom_title: `clique-${tagNamePlan({
          bonus: this.bonus,
          franchise: this.franchise,
        })}:aplicar`,
      });
    }

    this.setTag(
      {
        event: "event",
        eventCategory: "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: "cupom:aplicar",
      },
      param
    );

    this.checkCupom({
      cupom: this.ticket.toUpperCase(),
      catalogOfferId: this.catalogId,
    })
      .then((response) => {
        const newCoupon = {
          discounts: response.content.reward.discounts,
          amount: response.content.reward.discounts[0].value.amount,
          off: response.off,
          code: response.content.code,
          rescueType: response.content.couponRescue.couponRescueType,
          description: response.content.description,
          planId: this.planId,
          catalogId: this.catalogId,
        };
        this.updateCoupons(newCoupon);

        if (this.customer.purchaseOrderId.length > 0) {
          this.validateCoupon();
        }

        this.ticketGood = response.content.code;
        this.ticketDesc = response.content.description;
        this.cupom = false;
        this.$emit("success", newCoupon);
        this.setCoupons(newCoupon);
        this.setTag(
          {
            event: "event",
            eventCategory: "claro-flex:checkout",
            eventAction: "callback:confirmar-cupom",
            eventLabel: "cupom:sucesso",
          },
          param
        );
      })
      .catch((error) => {
        this.showModalAlert = true;
        const err = JSON.parse(error);
        switch (err.code) {
          case "INVALID_COUPON_CODE":
            this.alertMessage = "Cupom inválido.";
            break;
          case "INVALID_CATALOG_COUPON_CODE":
            this.alertMessage = "Cupom inválido para esse produto.";
            break;
          default:
            this.alertMessage = err.message;
            break;
        }
        this.setTag(
          {
            event: "event",
            eventCategory: "claro-flex:checkout",
            eventAction: "callback:confirmar-cupom",
            eventLabel: "erro:".concat(this.alertMessage),
          },
          param
        );
      });
  }

  setTag(obj: object, flag: boolean): void {
    const win = window as any;
    if (this.$gtm.enabled() && !flag) {
      win.dataLayer.push(obj);
    }
  }

  created() {
    if (this.coupon && !this.isCarousel && this.planId === this.coupon.planId) {
      this.ticketGood = this.coupon.code;
      this.ticketDesc = this.coupon.description;
      this.cupom = false;
    } else if (
      this.couponCode !== "" &&
      this.catalogId !== "" &&
      !this.isMeli
    ) {
      this.checkCupom({
        cupom: this.couponCode.toUpperCase(),
        catalogOfferId: this.catalogId,
      })
        .then((response) => {
          const newCoupon = {
            discounts: response.content.reward.discounts,
            amount: response.content.reward.discounts[0].value.amount,
            off: response.off || false,
            code: response.content.code,
            rescueType: response.content.couponRescue.couponRescueType,
            description: response.content.description,
            planId: this.planId,
            catalogId: this.catalogId,
          };
          this.setCoupon(newCoupon);
          this.setCoupons(newCoupon);

          this.ticketGood = response.content.code;
          this.ticketDesc = response.content.description;
          this.cupom = false;
          this.$emit("success", newCoupon);
        })
        .catch((error) => {
          this.showModalAlert = true;
          const err = JSON.parse(error);
          switch (err.code) {
            case "INVALID_COUPON_CODE":
              this.alertMessage = "Cupom inválido.";
              break;
            case "INVALID_CATALOG_COUPON_CODE":
              this.alertMessage = "Cupom inválido para esse produto.";
              break;
            default:
              this.alertMessage = err.message;
              break;
          }
        });
    } else {
      this.cupom = false;
    }
  }
}
